import { GET_ADMIN_MEMBERSHIP, GET_ADMIN_MEMBERSHIP_SUCCESS, GET_ADMIN_MEMBERSHIP_ERROR, GET_ADMIN_MEMBERSHIP_EMPTY } from '../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetAdminMembershipsData = (state = initialState, action) => {
  switch (action.type) {
    case GET_ADMIN_MEMBERSHIP:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_ADMIN_MEMBERSHIP_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };

      break;

    case GET_ADMIN_MEMBERSHIP_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_ADMIN_MEMBERSHIP_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetAdminMembershipsData;
